import { ContextType, IContext } from './ContextType';
import { IGameState } from './IGameState';
import { initialLevelState } from '../Level/initialLevelState';
import { initialPlatformState } from './IPlatformState';
import { initialPlayerState } from '../Player/initialPlayerStates';
import { AsyncActionStatus } from '../AsyncAction';
import { defaultCanvasSize } from 'Constants/Canvas';
import { initialWorldState } from '../World/IWorldState';
import { initialTimerState } from '../Timer/ITimerState';
import { initialUIState } from '../UI/IUIState';
import { initialPerSessionDataState } from './IPerSessionData';
import { initialFarmState } from 'State/Farm/initialFarmState';
import { initialEventsState } from 'State/Events/initialEventsState';
import { initialPlinkoState } from 'State/Plinko/initialPlinkoState';

export const initialContext: IContext = {
    current: ContextType.DEFAULT,
    audioEnabled: true,
};

export const initialState: IGameState = {
    gamePaused: false,
    gameLoaded: false,
    context: initialContext,
    entryPoint: null,
    levelState: initialLevelState,
    worldState: initialWorldState,
    farmState: initialFarmState,
    plinkoState: initialPlinkoState,
    UIState: initialUIState,
    platform: initialPlatformState,
    userState: null,
    playerState: initialPlayerState,
    activeScene: {
        status: AsyncActionStatus.EMPTY,
        result: null,
    },
    timerState: initialTimerState,
    eventsState: initialEventsState,
    canvasSize: defaultCanvasSize,
    perSessionData: initialPerSessionDataState,
    dataConflict: {
        status: AsyncActionStatus.EMPTY,
        result: null,
    },
    gbcStatus: AsyncActionStatus.EMPTY,
};
